<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">RSS</h1>
      <p class="page-tit">RSS</p>
    </div>

    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">RSS 서비스 안내</h2>
      <div class="notice-box" role="note" aria-label="시행일 안내">
        <p class="notice-box__text">
          RSS리더 프로그램을 설치하신 후, 한국인터넷진흥원에서 RSS 서비스를
          제공하는 게시물을 등록하시면 일일이 사이트에 방문하지 않아도 최근
          게시물을 실시간으로 편리하게 받아볼수 있으며, 홈페이지나 블로그에
          복사하여 방문자에게 한국인터넷진흥원에서 제공하는 서비스를 제공할 수
          있습니다.
        </p>
      </div>
      <p class="section-inter-title">RSS 리더 프로그램 다운로드</p>
      <div class="media-row">
        <p>
          <img src="@/assets/img/rss_btn.png" alt="" />
        </p>
        <p class="media-row__desc">
          <span class="notice-box__tit">
            한국인터넷진흥원에 새로운 글을 RSS로 등록하여 빠르게
            확인하세요.</span
          ><br />
          - RSS는 사이트에 새로올라오는 글을 쉽게 구독할 수 있도록 하는 규칙이며
          사용자가 보다 편리하게 내용을 구독할 수 있습니다.
        </p>
      </div>
      <ul class="source-card__list">
        <li>
          <a
            class="source-card"
            href="https://chromewebstore.google.com/detail/slick-rss-by-users/lloonpjjgockligalihhebapcafgbgef"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="source-card__brand" aria-hidden="true">
              <img
                src="../../assets/img/company/chrome-logo.svg"
                alt=""
              />브라우져가 chrome일 경우 -
            </span>
            <span>Slick Rss</span>
          </a>
        </li>

        <li>
          <a
            class="source-card"
            href="https://microsoftedge.microsoft.com/addons/detail/feeder-rss-feed-reader/jlkhefogiiibhgblliimeleiiiijbkjj?hl=ko-kr"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="source-card__brand" aria-hidden="true">
              <img
                src="../../assets/img/company/edge_logo.svg"
                alt=""
              />브라우져가 Edge일 경우 -
            </span>
            <span>RSS Feed Reader</span>
          </a>
        </li>
      </ul>
    </section>

    <section class="section-pt">
      <h2 class="section-title">한국인터넷진흥원에서 제공하는 RSS 목록</h2>

      <p class="desc-block">
        아래 주소복사를 선택한 후에 RSS리더 프로그램에 추가하시면 됩니다.
      </p>

      <ul class="rss-card-grid__list" role="list" :key="index">
        <li
          class="rss-card-grid__item"
          aria-labelledby="card-collect-title"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="rss-card-grid__head">
            <div class="rss-card-grid__cont">
              <h3 class="rss-card-grid__title">{{ item.rssName }}</h3>
              <p class="rss-card-grid__desc">{{ item.rssUrl }}</p>
              <button
                type="button"
                class="btn btn--blue btn--m"
                @click="copyText(item)"
              >
                <i class="pi pi-clipboard"></i>주소 복사
              </button>
            </div>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { copyToClipboard } from "@/component/Clipboard.js";

export default {
  setup() {
    const axios = inject("axios");
    const store = useStore();

    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const items = ref([]);

    //methods 정의
    const getList = () => {
      showLoading();
      axios
        .post("/core/pu/view/rss/get", {})
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            items.value = res.data.resList;
          } else {
            items.value = [];
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const copyText = async (item) => {
      const success = await copyToClipboard("주소가", item.rssUrl);
      if (success) {
        axios
          .get("/core/pu/rss/stats/count", { params: { name: item.rssName } })
          .catch((error) => {
            console.error(error);
          });
      }
    };

    // life cycle 정의
    onMounted(() => {
      getList();
    });

    // html에서 사용될 데이터 정의
    return {
      items,
      copyText,
    };
  },
};
</script>
<style scoped>
.card-grid__wrap {
  overflow: auto;
}
</style>